export default {
  ERROR: 'compilationEditToolbarError'
};
